import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PaginationComponent } from '@merchant-portal/app/components/pagination/pagination.component';
import { CardModule } from 'primeng/card';
import { DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { SelectModule } from 'primeng/select';
import { CoreModule } from 'projects/merchant-portal/src/app/core/core.module';
import { ButtonComponent, InputModule } from 'ui-component/src/public-api';
import { BeneficiaryListComponent } from './beneficiary-list.component';
import { BeneficiaryListApiFatoryService } from './factory/beneficiary-list-api-fatory.service';
import { BeneficiaryListFactoryService } from './factory/beneficiary-list-store-factory';
import { BeneficiaryListApiService } from './services/beneficiary-list.api.service';
import { BeneficiaryListService } from './services/beneficiary-list.service';
@NgModule({
  declarations: [BeneficiaryListComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    CardModule,
    DatePickerModule,
    CoreModule,
    FormsModule,
    InputTextModule,
    SelectModule,
    PaginatorModule,
    PaginationComponent,
    ButtonComponent,
    InputModule,
  ],
  exports: [BeneficiaryListComponent],
  providers: [
    {
      provide: BeneficiaryListFactoryService,
      useClass: BeneficiaryListService,
    },
    {
      provide: BeneficiaryListApiFatoryService,
      useClass: BeneficiaryListApiService,
    },
  ],
})
export class BeneficiaryListModule {}
